const SECTION_ID = 'cart-drawer';

class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.drawer = this.querySelector('site-drawer');
    this.contents = this.querySelector('[data-cart-contents]');

    // Any add-to-cart on the site dispatches this; re-render and open.
    this._onCartUpdated = () => this.refresh({ open: true });
    window.addEventListener('cart:updated', this._onCartUpdated);

    // Delegated quantity buttons / remove (survives content re-render).
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-qty-increment]')) this.step(e.target, 1);
      else if (e.target.closest('[data-qty-decrement]')) this.step(e.target, -1);
      else if (e.target.closest('[data-cart-remove]')) this.remove(e.target);
    });

    // Direct edit of the quantity field.
    this.addEventListener('change', (e) => {
      if (e.target.matches('[data-qty-input]')) {
        const wrap = e.target.closest('[data-line]');
        this.change(wrap.dataset.line, parseInt(e.target.value, 10) || 0);
      }
    });
  }

  disconnectedCallback() {
    window.removeEventListener('cart:updated', this._onCartUpdated);
  }

  step(el, delta) {
    const wrap = el.closest('[data-line]');
    const input = wrap.querySelector('[data-qty-input]');
    const next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
    input.value = next;
    this.change(wrap.dataset.line, next);
  }

  remove(el) {
    const wrap = el.closest('[data-line]');
    el.closest('[data-cart-item]')?.setAttribute('aria-busy', 'true');
    this.change(wrap.dataset.line, 0);
  }

  async change(line, quantity) {
    this.setBusy(true);
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          line: Number(line),
          quantity,
          sections: SECTION_ID,
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        this.showError(data.description || 'Something went wrong updating your cart.');
        return;
      }
      this.render(data.sections[SECTION_ID]);
      this.syncBadge(data.item_count);
    } catch (err) {
      console.error(err);
      this.showError('Something went wrong updating your cart.');
    } finally {
      this.setBusy(false);
    }
  }

  async refresh({ open = false } = {}) {
    try {
      const res = await fetch(`${window.Shopify.routes.root}?section_id=${SECTION_ID}`);
      const text = await res.text();
      this.render(text);
      const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((r) =>
        r.json(),
      );
      this.syncBadge(cart.item_count);
      if (open && this.drawer && !this.drawer.dialog.open) this.drawer.open();
    } catch (err) {
      console.error(err);
    }
  }

  render(sectionHtml) {
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const next = doc.querySelector('[data-cart-contents]');
    if (next) this.contents.innerHTML = next.innerHTML;
  }

  syncBadge(count) {
    const badge = document.querySelector('[data-cart-count-badge]');
    if (!badge) return;
    badge.textContent = count;
    badge.hidden = count < 1;
  }

  setBusy(state) {
    this.contents.setAttribute('aria-busy', state ? 'true' : 'false');
  }

  showError(message) {
    const box = this.contents.querySelector('[data-cart-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }
}

customElements.define('cart-drawer', CartDrawer);
